import React, { useState } from 'react'
import './Teams.css';
import { Table, TableHead, TableRow, TableCell, makeStyles, TablePagination, TableSortLabel } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3),
        '& thead th': {
            fontWeight: '600',
            color: 'white',
            backgroundColor: '#8D002E',
        },
        '& tbody tgd': {
            fontWeight: '300',
        },
        '& tbody tr:hover': {
            backgroundColor: 'gray',
            cursor: 'pointer',
        },
    },
}))

export default function TeamTable(records, headCells, filterFn) {

    const classes = useStyles();
    const [modal, setModal] = useState(false);
    const openCloseModal = () => {
        setModal(!modal);
    }
    const pages = [5, 10, 15]
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(pages[page])
    const [order, setOrder] = useState()
    const [orderBy, setOrderBy] = useState()

    const TblContainer = props => (
        <Table className="table">
            {props.children}
        </Table>
    )

    const TblHead = props => {


        return (<TableHead>
            <TableRow>
                {
                    headCells.map(headCell => (
                        <TableCell key={headCell.id}
                        >
                            {headCell.label}
                        </TableCell>))
                }
            </TableRow>
        </TableHead>)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0);
    }

    const TblPagination = () => (<TablePagination
        component="div"
        page={page}
        rowsPerPageOptions={pages}
        rowsPerPage={rowsPerPage}
        count={records.length}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas"
        labelDisplayedRows={({ from, to, count }) => `Registros ${from}-${to} de ${count}`}
    />)



    const recordsAfterPagingAndSorting = () => {
        return (records).slice(page * rowsPerPage, (page + 1) * rowsPerPage)
    }

    return {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    }
}